export const MUSIC_PLAY = 'MUSIC_PLAY';
export const MUSIC_PAUSE = 'MUSIC_PAUSE';
export const LANG_DE = 'LANG_DE';
export const LANG_EN = 'LANG_EN';
export const LANG_RU = 'LANG_RU';

export function music_play() {
  return {
    type: MUSIC_PLAY
  };
}

export function music_pause() {
  return {
    type: MUSIC_PAUSE
  };
}

export function lang_de() {
  return {
    type: LANG_DE
  };
}

export function lang_en() {
  return {
    type: LANG_EN
  };
}

export function lang_ru() {
  return {
    type: LANG_RU
  };
}



// WEBPACK FOOTER //
// ./src/actions/nav.js